import React from "react";
import { Media } from "../../Media/Media";
import { Stack } from "../../Stacks/Stack/Stack";
import { Text } from "../../Text/Text";
import { ChoiceGroupProps } from "../ChoiceGroup";
import { LineItem, LineItemChoices, MediaLineItem } from "../variants/SelectButtonChoiceGroup/SelectButtonChoiceGroup";
import { getTextVariant, headerPadding } from "./styles";

export const getButtonText = (text: string, disabled?: boolean, topRightText?: LineItem, optionType?: ChoiceGroupProps["optionType"], subTextWithMedia?: MediaLineItem): JSX.Element => {
    const textIsNotEmpty = text.trim().length > 0;
    const selectButtonTextPadding = "0px 0px 14px";
    const selectButtonWithSubTextPadding = "0px 0px 6px";
    const selectButtonHeaderPadding = subTextWithMedia ? selectButtonWithSubTextPadding : selectButtonTextPadding;

    return (
        <>
            <Stack horizontal={true}>
                {textIsNotEmpty && (
                    <Stack padding={optionType === "selectButton" ? selectButtonHeaderPadding : headerPadding} grow={1}>
                        <Text variant={getTextVariant(disabled)} weightOverride="bold">{text}</Text>
                    </Stack>
                )}

                {topRightText && (
                    <Stack padding={optionType === "selectButton" ? selectButtonHeaderPadding : headerPadding} horizontalAlign="end" grow={1}>
                        <Text variant={getTextVariant(disabled)} weightOverride={topRightText.isBold ? "bold" : undefined}>{topRightText.text}</Text>
                    </Stack>
                )}
            </Stack>
            {subTextWithMedia && (
                <Media padding={"0px 0px 25px"} {...subTextWithMedia} >
                    <Text variant={getTextVariant(disabled)} weightOverride="bold">
                        {subTextWithMedia.text}
                    </Text>
                </Media>
            )}
        </>
    );
};

export const getSelectButtonLineItems = (lines?: readonly LineItemChoices[], disabled?: boolean): JSX.Element => {
    return (
        <>
            {lines && lines.map((line, index) => {
                if (line.lineItemType === "media") {
                    return (
                        <Media key={index} {...line} disabled={disabled}>
                            <Text variant={getTextVariant(disabled)} weightOverride={line.isBold ? "bold" : undefined}>
                                {line.text}
                            </Text>
                        </Media>
                    );
                } else {
                    return (
                        <Text key={index} variant={getTextVariant(disabled)} weightOverride={line.isBold ? "bold" : undefined}>{line.text}</Text>
                    );
                }
            })}
        </>
    );
};
